<template>
  <div class="SkuSelectorContainer">
    <nut-row class="leftCenter">
      <img :src="skus[selected].skuImage" class="sqr60 brd6">
      <nut-row class="leftCenter pl8">
        <span class="numberText ft14">¥</span>
        <span class="numberText ft26">{{(skus[selected].price/100.0).toFixed(2)}}</span>
      </nut-row>
    </nut-row>

    <nut-radiogroup v-model="selected" direction="horizontal" class="mt24">
      <template v-for="(s,si) in skus" :key="`sku_${si}`">
      <nut-radio shape="button" :label="si">{{ s.skuName }}</nut-radio>
      </template>
    </nut-radiogroup>

    <nut-row class="mt24">
    <nut-button size="large"
                @click="$emit('buySku',skus[selected])"
                class="buyBtn wft" style="font-size: 18px">立即报名</nut-button>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "SkuSelector",
  props: {
    skus: {
      type: Array,
      default: ()=>{
        return []
      }
    },
  },
  data() {
    return {
      selected: 0,
    }
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SkuSelectorContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 24px 16px;

  .buyBtn {
    border: none;
    background: linear-gradient(0deg, #E05E1D 0%, #EF773B 100%);
  }
}
</style>